import { useState, useEffect, useRef } from 'react';
import { Comment } from 'react-loader-spinner';
import { addContactRequest } from "../../api/ContactAPI";
import './JoinModal.css';
import { useModal } from "../../contexts/ModalContext";

const JoinModal = ({ isOpen, onClose }) => {

    const { openModal } = useModal();

    const [isLoading, setIsLoading] = useState(false);
    const [fName, setfName] = useState("");
    const [lName, setlName] = useState("");
    const [email, setemail] = useState("");
    const [request, setrequest] = useState("");
    const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null
    const firstInputRef = useRef(null);

    // Focus first input when modal opens
    useEffect(() => {
        if (isOpen && firstInputRef.current) {
            setTimeout(() => firstInputRef.current.focus(), 100);
        }
    }, [isOpen]);

    // Handle ESC key
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);

    // Prevent background scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    const resetForm = () => {
        setfName("");
        setlName("");
        setemail("");
        setrequest("");
        setSubmitStatus(null);
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent page refresh
        // Call your function here
        createContactRequest();
    };

    async function createContactRequest() {

        setIsLoading(true);
        const requestProps = {
            fName: fName,
            lName: lName,
            email: email,
            request: request,
            forNewroConnect: true
        };
        // Call your API function here
        const res = await addContactRequest(requestProps);
        if (res.success) {
            openModal("alert", {
                alertProps: { type: 2, message: "Request sent successfully!" },
            });
            setfName("");
            setlName("");
            setemail("");
            setrequest("");
        } else {
            openModal("alert", {
                alertProps: { type: 0, message: "Request error, please try again." },
            });
        }
        setTimeout(() => {
            handleClose();
        }, 2000);
        setIsLoading(false);
    }

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="join-modal-overlay" onClick={handleOverlayClick}>
            <div className="join-modal" role="dialog" aria-modal="true" aria-labelledby="join-modal-title">
                <button
                    className="join-modal-close"
                    onClick={handleClose}
                    aria-label="Close modal"
                >
                    <CloseIcon />
                </button>

                <div className="join-modal-content">
                    <h2 id="join-modal-title" className="join-modal-title">Join Newro Connect</h2>
                    <p className="join-modal-subtitle">
                        Share your details to be featured on the Newro Connect page.
                    </p>

                    {submitStatus === 'success' ? (
                        <div className="join-modal-success">
                            <CheckCircleIcon />
                            <p>Request sent successfully! We'll be in touch soon.</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="join-modal-form">
                            <div className="join-modal-row">
                                <input
                                    ref={firstInputRef}
                                    onChange={(e) => setfName(e.target.value)}
                                    value={fName}
                                    type="text"
                                    placeholder="First Name"
                                    required
                                    className="join-modal-input"
                                />
                                <input
                                    onChange={(e) => setlName(e.target.value)}
                                    value={lName}
                                    type="text"
                                    placeholder="Last Name"
                                    required
                                    className="join-modal-input"
                                />
                            </div>
                            <input
                                onChange={(e) => setemail(e.target.value)}
                                value={email}
                                type="email"
                                placeholder="Email"
                                required
                                className="join-modal-input"
                            />
                            <textarea
                                onChange={(e) => setrequest(e.target.value)}
                                value={request}
                                placeholder="Tell us about yourself and your expertise..."
                                rows="4"
                                required
                                className="join-modal-textarea"
                            />

                            {submitStatus === 'error' && (
                                <div className="join-modal-error">
                                    <p>Request error, please try again.</p>
                                </div>
                            )}

                            <button type="submit" className="join-modal-submit" disabled={isLoading}>
                                {isLoading ? (
                                    <Comment
                                        visible={true}
                                        height="30"
                                        width="30"
                                        ariaLabel="comment-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="comment-wrapper"
                                        color="#10b981"
                                        backgroundColor="#ffffff"
                                    />
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default JoinModal;

const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
    </svg>
);

const CheckCircleIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="m9 12 2 2 4-4" />
    </svg>
);
